import { useCallback } from "react";
import { Grid } from "@mui/material";

import { useThermowatch } from "./ThermowatchTemplate";
import BatterySettings from "./BatterySettings";
import { BatterySettingsValue, CommSettingsValue, RssiSettingsValue } from "./types";
import { cloneDeep } from "lodash-es";
import RssiSettings from "./RssiSettings";
import CommSettings from "./CommSettings";

const ThermowatchDeviceSettings = () => {
  const { value, saved, setValue } = useThermowatch();

  const onBatteryChange = useCallback(
    (v: BatterySettingsValue) => {
      value.battery = v;
      setValue(value);
    },
    [value, setValue]
  );
  const onRssiChange = useCallback(
    (v: RssiSettingsValue) => {
      value.rssi = v;
      setValue(value);
    },
    [value, setValue]
  );
  const onCommChange = useCallback(
    (v: CommSettingsValue) => {
      value.comm = v;
      setValue(value);
    },
    [value, setValue]
  );

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <BatterySettings value={cloneDeep(value.battery)} saved={saved?.battery || null} onChange={onBatteryChange} />
      </Grid>
      <Grid item xs={12}>
        <RssiSettings value={cloneDeep(value.rssi)} saved={saved?.rssi || null} onChange={onRssiChange} />
      </Grid>
      <Grid item xs={12}>
        <CommSettings value={cloneDeep(value.comm)} saved={saved?.comm || null} onChange={onCommChange} />
      </Grid>
    </Grid>
  );
};

export default ThermowatchDeviceSettings;
